import { render, staticRenderFns } from "./ServiceDetail.vue?vue&type=template&id=db1956c8&"
import script from "./ServiceDetail.vue?vue&type=script&lang=js&"
export * from "./ServiceDetail.vue?vue&type=script&lang=js&"
import style0 from "./ServiceDetail.vue?vue&type=style&index=0&id=db1956c8&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('db1956c8')) {
      api.createRecord('db1956c8', component.options)
    } else {
      api.reload('db1956c8', component.options)
    }
    module.hot.accept("./ServiceDetail.vue?vue&type=template&id=db1956c8&", function () {
      api.rerender('db1956c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ServiceDetail.vue"
export default component.exports